<!-- #737: Benachrichtigungs-Diagnose. Kopfzeilen nach user-list.component.html. -->
<div>

  <nx-pageTitle-box
    [label]="'core.notificationDiagnostics.pageTitle.label'"
    [icon]="'icon-notification'"
    [iconToolTip]="'core.notificationDiagnostics.pageTitle.iconTooltip'"
    [bcRootLvlLabel]="'core.settings.label'"
    [bcRootLvlPath]="'settings'">
    <!-- §6.6: nur fuer framework_nexato_employee, ausgeblendet statt disabled — wie der
         Testversand in den Profil-Einstellungen. disabled nur waehrend der laufenden Mutation. -->
    <ng-template nxTemplate="end">
      @if (canSeedDemo) {
        <nx-default-button
          [disabled]="seedingDemo()"
          [label]="'core.notificationDiagnostics.seedDemo.buttonLabel' | translate"
          [tooltip]="'core.notificationDiagnostics.seedDemo.buttonLabel' | translate"
          [icon]="'icon-plus'"
          [style]="'light'"
          (click)="onSeedDemo()">
        </nx-default-button>
      }
    </ng-template>
  </nx-pageTitle-box>

  <!-- Leere Panels, die nur ihre Kopfzeile tragen; der Inhalt steht darunter. Dasselbe Muster wie
       notifications-page.html (#736) — erspart die Frage nach Lazy-Rendering und Panel-Cache. -->
  <div class="flex flex-row">
    <div class="w-full">
      <p-tabView [activeIndex]="activeTabIndex()" (activeIndexChange)="onTabChange($event)">
        <p-tabPanel>
          <ng-template pTemplate="header">
            <span>{{ 'core.notificationDiagnostics.tabs.messages' | translate }}</span>
          </ng-template>
        </p-tabPanel>
        <p-tabPanel>
          <ng-template pTemplate="header">
            <span>{{ 'core.notificationDiagnostics.tabs.deliveries' | translate }}</span>
          </ng-template>
        </p-tabPanel>
      </p-tabView>
    </div>
  </div>

  <!-- Kein border-t auf dem Inhalt: .p-tabview-nav bringt bereits eine untere Linie mit
       (ng-theme.scss:12-15), ein zusaetzlicher oberer Rahmen ergaebe eine Doppellinie. -->
  @if (activeTab() === 'messages') {
    <app-notification-admin-list
      [users]="users()"
      [typeOptions]="typeOptions()">
    </app-notification-admin-list>
  } @else {
    <app-notification-delivery-list
      [users]="users()"
      [typeOptions]="typeOptions()">
    </app-notification-delivery-list>
  }
</div>
